var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpListPage',{attrs:{"id":"HELP_PAGE_CADASTRAL_INFO","heading":_vm.$t('helpPage.cadastralPage.heading'),"title":_vm.$t('helpPage.cadastralPage.title'),"description":_vm.$t('helpPage.cadastralPage.description')}})}
var staticRenderFns = []

export { render, staticRenderFns }